<div class="sales-message">

  <div class="sales-message__title checkbox-element checkbox-element--hidden-disabled">
    <mat-checkbox [checked]="true" [disabled]="true">
      {{ config.title | translate }}
    </mat-checkbox>
  </div>

  <div class="sales-message__info">
    <ul>
      <li *ngFor="let item of config.listItems" [innerHTML]="item | translate | safeHtml"></li>
    </ul>
  </div>

  <div class="sales-message__images">
    <img *ngFor="let image of config.images"
         [width]="image.attrWidth ? image.attrWidth : undefined"
         [height]="image.attrHeight ? image.attrHeight : undefined"
         [ngStyle]="{
            'min-width.px': image.minWidth,
            'max-height.px': image.maxHeight,
            'max-width.px': image.maxWidth,
            'margin-left.px': image.marginLeft
          }"
         [src]="image.src">
  </div>

</div>
